


















import CompanyUserRequired from "../CompanyRequired";
import {Component, Inject} from "vue-property-decorator";
import Api from "@/components/systemsettings/Api";
import {HseGuideline} from "@/modules/models";
import HseGuidelineCard from "@/components/systemsettings/HseGuidelineCard.vue";
import rd from "@/modules/vRoutedefs";

@Component({
  components: {
    "at-hseguideline-card": HseGuidelineCard,
  }
})
export default class HseGuidelinesPage extends CompanyUserRequired {
  @Inject()
  api!: Api;

  readonly docTo = rd.docs.hseguidelines.path;

  guidelines: HseGuideline[] = [];

  async loadData() {
    this.guidelines = await this.api.listHseGuidelines(this.company.orgNum);
  }

  created() {
    this.loadData();
  }
}
